import { partnerClient } from '@modules/core/services';
import { CHART_KEY_DAILY_DATE_FORMAT, formatDate } from '@common/utils';
import { UseQuerySampleTrackingParams } from '../hooks/useQuerySampleTracking.types';
import { SampleTrackingResponse } from '../types';

export const fetchSampleTrackingV2 = async (
  queryParams: UseQuerySampleTrackingParams,
): Promise<SampleTrackingResponse> => {
  const { offset, limit, start, end, collectionLocation, query } = queryParams;
  const status = queryParams.status?.join(',');
  const sampleType = queryParams.sampleType?.join(',');

  const sort: string[] = [];
  if (queryParams.sort) {
    Object.entries(queryParams.sort).forEach(([column, asc]) => {
      sort.push(`${asc ? '' : '-'}${column}`);
    });
  }

  let startDate = queryParams?.start;
  if (start && start instanceof Date) {
    startDate = formatDate(start, CHART_KEY_DAILY_DATE_FORMAT);
  }

  let endDate = queryParams?.end;
  if (end && end instanceof Date) {
    endDate = formatDate(end, CHART_KEY_DAILY_DATE_FORMAT);
  }

  try {
    return await partnerClient.get(`/studies/-/samples/v2`, {
      params: {
        offset,
        limit,
        start: startDate,
        end: endDate,
        sampleStatus: status,
        sampleType,
        collectionLocation,
        query,
        // TODO: Change component so the sort state is only 1 column
        // We only support sorting by one column in API
        sort: sort[0],
      },
    });
  } catch (err: unknown) {
    throw new Error(err as string);
  }
};
